<template>
    <div class="main">
           <news-list :url="url" ></news-list>
    </div>
</template>

<script>
  import newsList from './newsLists/newsList.vue'

  export default {
    name: "website",
    data() {
      return {
        url:'website'
      }
    },
    components:{newsList},
    created: function () {
      sessionStorage.removeItem('tutorialHover');
    },
    methods: {

    }
  }
</script>

<style scoped>
  .main {
    width: 1170px;
    margin: auto auto 15px auto;
    min-height: calc(100% - 486px);
  }

  /*条件筛选*/
  .sort-bg {
    border: #ddd 1px solid;
    margin: 15px auto;
    padding: 15px 15px;
  }

  .brand-sort-bg {
    display: flex;
    align-items: baseline;
    font-size: 14px;
    border-bottom: #ddd 1px dashed;
    margin-bottom: 20px;
    padding-bottom: 20px;
  }

  .brand-sort-bg:last-child {
    margin-bottom: 0;
    border-bottom: none;
    padding-bottom: 0;
  }

  .sort-title {
    color: #666;
    margin-right: 15px;
    width: 60px;
    text-align: left;
  }

  .brand-sort-bg ul {
    display: flex;
    flex-wrap: wrap;
    max-height: 60px;
    overflow-y: auto;
  }

  .brand-sort-bg ul li {
    padding: 0 15px;
    line-height: 30px;
  }

  .brand-sort-bg ul li:hover, .brand-sort-bg ul li.hover {
    color: #e60000;
    cursor: pointer;
  }

  @media screen and (max-width: 1024px) {
    .main {
      width: 100%;
    }

  }

</style>



// WEBPACK FOOTER //
// src/components/website.vue